import dayjs, {Dayjs} from 'dayjs';
import {json, JsonMappers} from '../../../core/data-source/json.mapper';
import {VehicleChecksFaultsFormSubmissioRecord} from './vehicle-checks-faults-form-submission.record';

export class VehicleChecksFaultsFormRecord {
    @json()
    reference: string;

    @json()
    driverName: string;

    @json()
    regNumber: string;

    @json()
    checkName: string;

    @json({
        mapper: {from: (value: any): string => dayjs.utc(value).format('DD/MM/YYYY')}
    })
    registeredDate: string;

    @json()
    status: string;

    @json(JsonMappers.InstanceOf(() => VehicleChecksFaultsFormSubmissioRecord))
    fault: VehicleChecksFaultsFormSubmissioRecord;

    @json({
        mapper: {
            from: (value: string): Dayjs => dayjs.utc(value)
        }
    })
    rectifiedDate: Dayjs;

    @json()
    resolutionComment: string;

    @json()
    rectifiedBy: string;

    @json()
    signature: string;

    @json()
    signedBy: string;
}
